import { render, staticRenderFns } from "./wechat_pay.vue?vue&type=template&id=d4858c68&scoped=true"
import script from "./wechat_pay.vue?vue&type=script&lang=js"
export * from "./wechat_pay.vue?vue&type=script&lang=js"
import style0 from "./wechat_pay.vue?vue&type=style&index=0&id=d4858c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4858c68",
  null
  
)

export default component.exports